/**
 * Localization messages for RuleDetails component
 */
import sharedMessages from '../../shared/messages/sharedMessages';
import { mergeInvertedMessages } from '../../utils/localization';

const componentMessages = {
  // Component-specific messages
  'Review rule conditions and included access before converting to a Technical or Birthright Rule':
    'ruleRecs.ruleDetails.subtitle',
  'A technical rule already exists in the system with this name':
    'ruleRecs.ruleDetails.error.ruleAlreadyExists',
} as const;

const invertedMessages = mergeInvertedMessages(
  sharedMessages,
  componentMessages
);

export type RuleDetailsMessage = keyof typeof invertedMessages;

export default invertedMessages;
